export default "__VITE_ASSET__54d40adc__"